import { Component, OnInit } from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {PgStorageService} from "../../../policy-guidelines/services/pg-storage.service";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {ActivatedRoute, Router} from "@angular/router";
import {StpRegistrationStorageService} from "../../../stp-registration/services/stp-registration-storage.service";
import {UtilityService} from "../../../../shared/services/utility.service";
import {CommonStorageService} from "../../../../shared/services/common-storage.service";
import {DomSanitizer} from "@angular/platform-browser";
import FileSaver from "file-saver";
import {
  TrainingAndAssessmentMaterialsStorageService
} from "../../../training-and-assessment-materials/services/training-and-assessment-materials-storage.service";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-verify-e-certificate',
  templateUrl: './verify-e-certificate.component.html',
  styleUrls: ['./verify-e-certificate.component.scss']
})
export class VerifyECertificateComponent implements OnInit {

  id : any;
  reportData: any[] = [];
  constructor(
    private notification: NzNotificationService,
    private activatedRoute: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private trainingAndAssessmentMaterialsStorageService: TrainingAndAssessmentMaterialsStorageService,
  ) {

    this.id = this.activatedRoute.snapshot.params.id;
    this.onDownloadJasperReport(this.id);

  }

  ngOnInit(): void {
  }

  onDownloadJasperReport(applicationId : any) {
    this.trainingAndAssessmentMaterialsStorageService
      .onVerifyApprvdOccByAppIdReportUsingJasper(
        applicationId)
      .subscribe({
        next: (response) => {
          this.ngxLoader.stop();
          if (response.success) {
            this.reportData = response.data;
            this.generateTableRows();
            console.log(this.reportData);
            this.notification.success('Success', response.message);
            this.notification.success('Success', response.message);
          } else {
            this.notification.error('Failed', 'No report data available');
          }
        },
        error: (error) => {
          this.ngxLoader.stop();
          this.notification.error(
            'Failed',
            error?.message || 'An unexpected error occurred'
          );
        },
      });
  }

  generateTableRows() {
    const tableBody = document.getElementById('report-table-body');

    if (tableBody) {
      // Clear existing rows if any
      tableBody.innerHTML = '';

      console.log(this.reportData);
      this.reportData.forEach(data => {
        const row = document.createElement('tr');

        // Create table cells for each property in the data
        row.innerHTML = `
        <td style="border: 1px solid #000;">${data.concatenatedValue || 'N/A'}</td>
        <td style="border: 1px solid #000;">${data.iasName || 'N/A'}</td>
        <td style="border: 1px solid #000;">${data.approvedAsCourseAccreditation || 'N/A'}</td>
        <td style="border: 1px solid #000;">${new DatePipe('en-US')
          .transform(data.validFromCourse, 'dd-MM-yyyy')
          ?.toString() +' to ' + new DatePipe('en-US')
          .transform(data.validToCourse, 'dd-MM-yyyy')
          ?.toString() || 'N/A'}</td>
        <td style="border: 1px solid #000;">${data.approvedAsAssessmentCenter || 'N/A'}</td>
        <td style="border: 1px solid #000;">${new DatePipe('en-US')
          .transform(data.validFromAssesment, 'dd-MM-yyyy')
          ?.toString() +' to ' + new DatePipe('en-US')
          .transform(data.validToAssesment, 'dd-MM-yyyy')
          ?.toString() || 'N/A'}</td>
      `;

        // Append the row to the table body
        tableBody.appendChild(row);
      });
    } else {
      console.error('Table body not found!');
    }
  }

  formatDate(date: any): string {
    if (!date) return '';

    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  }


}
